var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{class:{ readonly: _vm.readonly },attrs:{"maxlength":_vm.maxLength,"min":_vm.min,"max":_vm.max,"show-word-limit":"","disabled":_vm.disabled,"placeholder":_vm.placeholder,"readonly":_vm.readonly},model:{value:(_vm.numberValue),callback:function ($$v) {_vm.numberValue=$$v},expression:"numberValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }